<template>
  <div>
    <Card :dis-hover="true">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">搜索: </div>
            <Input v-model="searchval" style="width: 500px" >
                    <Select v-model="searchfield" slot="prepend" style="width: 80px">
                        <Option value="name">店铺名</Option>
                    </Select>
                    <Button @click="request" slot="append" icon="ios-search"></Button>
                </Input>
           
          </li>
        </ul>
      </div>
      <Divider dashed />
      <Table :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="name">
            <strong>{{ row.name }}</strong>
        </template>
        <template slot="action">
            <Button type="primary" size="small" style="margin-right: 5px" @click="authorize()">授权</Button>
        </template>
      </Table>
      <div class="page-wrap">            
        <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
    </Card>
  </div>
</template>
<script>
import RequestUtils from "@/utils/RequestUtils";
import conf from "@/views/im/conf";
export default {
  components: {
  },

  data() {
    return {
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      filter: {
        connector: 'lazada'
      },
      columns: [
          {
              title: '店铺名',
              key: 'name'
          },
          {
              title: '账号',
              key: 'account'
          },
          {
              title: '国家',
              key: 'country_text'
          },
          {
              title: '创建时间',
              key: 'created_at'
          },
          {
              title: '授权失效时间',
              key: 'im_expiresin_text'
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            render: (h, params) => {
              return h(
                'i-Switch',
                {
                  props: {
                    size: 'large',
                    value: params.row.status === 1
                  },
                  scopedSlots: {
                    open: () => h('span', '开启'),
                    close: () => h('span', '关闭')
                  },
                  on: {
                    'on-change': () => {
                      this.switchStatus(params)
                    }
                  }
                }
              )
            }
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },

  methods: {
    authorize () {
      let param = new FormData();
      param.set("appcate", 'IM');

      RequestUtils.request(conf.getAuthUrl(this.filter.connector), param)
      .then(data => {      
        window.open(data.url,"Add Account", "width=1024,height=600,toolbar=no,location=no,directories=no,status=no,menubar=yes,scrollbars=yes");
      })
    },
    switchStatus(item) {
      console.log(item);
      let param = new FormData();
      param.set('id', item.row.id );
      param.set('platform', this.filter.connector );
      param.set('status', item.row.status == 1 ? 0 : 1 );
      RequestUtils.request(conf.updateStoreStatus(), param)
      .then(() => {
        this.request();
      })
    },
    selectitem (key, value) {
      this.curPage = 1;
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let filter = JSON.parse(JSON.stringify(this.filter));
      if (this.searchval) {
        filter[this.searchfield] = this.searchval;
      }
      let param = new FormData();
      param.set("limit", this.pageSize);
      param.set("offset", (this.curPage-1)*this.pageSize );
      param.set("filter", JSON.stringify(filter) );
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getStorePageUrl(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.rows;
        self.loading = false;
      })
    }
  },

  created() {
    let self = this;
    this.request();
    window.addEventListener('message', function(e) {
        var data = e.data;
        console.log(data);
        if (data.event == 'refresh') {                
          self.request();
        } else if (data.event == 'error') {
            self.$Message.error(data.message);
        } else if (data.event == 'success') {
            self.request();
            self.$Message.success(data.message);
        }
    })  
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
